import { render, staticRenderFns } from "./SupportUs.vue?vue&type=template&id=672807e2&"
import script from "./SupportUs.vue?vue&type=script&lang=js&"
export * from "./SupportUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports